import { render, staticRenderFns } from "./SkillsForm.vue?vue&type=template&id=33760e20&scoped=true"
import script from "./SkillsForm.vue?vue&type=script&lang=js"
export * from "./SkillsForm.vue?vue&type=script&lang=js"
import style0 from "./SkillsForm.vue?vue&type=style&index=0&id=33760e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33760e20",
  null
  
)

export default component.exports